export const base = {
    background: "white",
    color: "black",
    params: {
        paddingtop: "-20px",
        paddingbottom: "10px"
    }
}